export default __webpack_public_path__ + "static/media/preview.c941099b.png";